import { Component, OnInit, Output, Input, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { SaveService } from '../../shared/services/save.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { User } from '../../shared/model/user';

const PASSWORD_REGEX = '(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$';

@Component({
  selector: 'user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.css']
})
export class UserFormComponent implements OnInit, OnChanges {

  @Output()
  outForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  @Input()
  inUser: User;
  @Input()
  inUserTypeInd: boolean;

  updateInd: boolean;
  updateTempo: boolean;

  form: FormGroup;

  constructor(private fb: FormBuilder,
    private saveService: SaveService) {

  }

  ngOnInit() {
    if (!this.inUser) {
      this.newForm();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inUser && changes.inUser.currentValue) {
      this.updateForm(changes.inUser.currentValue);
    }
  }

  newForm() {
    this.form = this.fb.group({
      userType: ['', this.radioButtonCheck],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      address: ['', Validators.required],
      city: ['', Validators.required],
      prov: ['Québec', Validators.required],
      country: ['Canada', Validators.required],
      postalCode: ['', Validators.required],
      phoneHouse: ['', Validators.required],
      phoneMobile: ['', Validators.required],
      phoneWork: ['', null],
      phoneExt: ['', null],
      emailGroup: this.fb.group({
        email: ['', [Validators.required, Validators.email]],
        emailConfirm: ['', Validators.required]
      }, { validator: this.validateEmailConfirmation }),
      passwordGroup: this.fb.group({
        password: ['', [Validators.required, Validators.pattern(PASSWORD_REGEX)]],
        passwordConfirm: ['', Validators.required]
      }, { validator: this.validatePasswordConfirmation }),
      notifyBySms: [false, null],
      notifyByEmail: [false, null],
      notifyByPhone: [false, null],
      notifyByPush: [false, null]
    });
    this.outForm.emit(this.form);
    this.form.valueChanges.subscribe(() => {
      this.outForm.emit(this.form);
    });
    this.updateInd = false;
    this.updateTempo = false;
  }

  updateForm(user: User) {
    this.updateInd = true;
    if (user.userType === "TEMPO") {
      this.updateTempo = true
      this.updateFormTempo(user);
    } else {
      this.updateFormAdminNormal(user);
    }
    this.outForm.emit(this.form);
    this.form.valueChanges.subscribe(() => {
      this.outForm.emit(this.form);
    });
  }

  updateFormAdminNormal(user: User) {
    this.form = this.fb.group({
      userType: [((user.userType === "ADMIN" || user.userType === "TEMPO") ? "1" : "2"), this.radioButtonCheck],
      firstName: [user.firstName, Validators.required],
      lastName: [user.lastName, Validators.required],
      address: [user.address, Validators.required],
      city: [user.city, Validators.required],
      prov: [user.prov, Validators.required],
      country: [user.country, Validators.required],
      postalCode: [user.postalCode, Validators.required],
      phoneHouse: [user.phoneHouse, Validators.required],
      phoneMobile: [user.phoneMobile, Validators.required],
      phoneWork: [user.phoneWork, null],
      phoneExt: [user.PhoneExt, null],
      notifyBySms: [user.notifyBySms, null],
      notifyByEmail: [user.notifyByEmail, null],
      notifyByPhone: [user.notifyByPhone, null],
      notifyByPush: [user.notifyByPush, null]
    });
    this.outForm.emit(this.form);
    this.form.valueChanges.subscribe(() => {
      this.outForm.emit(this.form);
    });
    if (user.userType === "TEMPO") {
      this.updateTempo = true
    }
    this.updateInd = true;
  }

  updateFormTempo(user: User) {
    this.form = this.fb.group({
      userType: ['1', this.radioButtonCheck],
      firstName: [user.firstName, Validators.required],
      lastName: [user.lastName, Validators.required],
      address: [user.address, Validators.required],
      city: [user.city, Validators.required],
      prov: [user.prov, Validators.required],
      country: [user.country, Validators.required],
      postalCode: [user.postalCode, Validators.required],
      phoneHouse: [user.phoneHouse, Validators.required],
      phoneMobile: [user.phoneMobile, Validators.required],
      phoneWork: [user.phoneWork, null],
      phoneExt: [user.PhoneExt, null],
      emailGroup: this.fb.group({
        email: [user.email, [Validators.required, Validators.email]],
        emailConfirm: [user.email, Validators.required]
      }, { validator: this.validateEmailConfirmation }),
      passwordGroup: this.fb.group({
        password: ['', Validators.required],
        passwordConfirm: ['', Validators.required]
      }, { validator: this.validatePasswordConfirmation }),
      notifyBySms: [user.notifyBySms, null],
      notifyByEmail: [user.notifyByEmail, null],
      notifyByPhone: [user.notifyByPhone, null],
      notifyByPush: [user.notifyByPush, null]
    });
  }

  radioButtonCheck = (control: FormControl): any => {
    if (control.value) {
      this.inUserTypeInd = false;
      return null;
    }
  }

  validateEmailConfirmation(group: FormGroup) {
    var email = group.controls['email'];
    var emailConfirm = group.controls['emailConfirm'];
    if (email.value !== emailConfirm.value) { // this is the trick
      emailConfirm.setErrors({ validateEmailConfirmation: true });
    }
    return null;
  }

  validatePasswordConfirmation(group: FormGroup) {
    var password = group.controls['password'];
    var passwordConfirm = group.controls['passwordConfirm'];
    if (password.value !== passwordConfirm.value) { // this is the trick
      passwordConfirm.setErrors({ validatePasswordConfirmation: true });
    }
    return null;
  }

  initFormTest() {
    // this.form.controls.userType.setValue("1");
    this.form.controls.firstName.setValue("Nick");
    this.form.controls.lastName.setValue("burdgard");
    this.form.controls.address.setValue("2345 rue Jarry");
    this.form.controls.city.setValue("H2B 2D5");
    this.form.controls.prov.setValue("Québec");
    this.form.controls.country.setValue("Canada");
    this.form.controls.postalCode.setValue("H2B 2D5");
    this.form.controls.phoneHouse.setValue("514-887-3421");
    this.form.controls.phoneMobile.setValue("514-444-5555");
    this.form.controls.phoneWork.setValue("514-444-6666");
    this.form.controls.phoneExt.setValue("321");
    if (!this.updateInd || this.updateTempo) {
      this.form.controls.emailGroup['controls'].email.setValue("isabelle@hotmail.com");
      this.form.controls.emailGroup['controls'].emailConfirm.setValue("isabelle@hotmail.com");
      this.form.controls.passwordGroup['controls'].password.setValue("Proij$18");
      this.form.controls.passwordGroup['controls'].passwordConfirm.setValue("Proij$18");
    }
    this.form.controls.notifyBySms.setValue(true);
    this.form.controls.notifyByEmail.setValue(false);
    this.form.controls.notifyByPhone.setValue(true);
    this.form.controls.notifyByPush.setValue(false);
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/users/user-form/user-form.component.ts